/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import MsDyn365 from '@msdyn365-commerce/core';
import * as React from 'react';
import { IMfrmSleepExpertsPickViewProps } from './mfrm-sleep-experts-pick';
import { Image, RichTextComponent } from '@msdyn365-commerce/core';
import { Button } from '@msdyn365-commerce-modules/utilities';
import classname from 'classnames';
import { ISleepExpertPicksCTALinkData, ITealiumEventData } from './mfrm-sleep-experts-pick.props.autogenerated';
import { Caret } from './svg/Caret';

export default (props: IMfrmSleepExpertsPickViewProps) => {
    const styles = 'd5-mfrm-sleep-expert-picks';
   const  {enableNewSleepExpertModule}=props.config;
   const {tealiumhChatEventActionText}=props.resources;
    const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent> | React.MouseEvent<HTMLAnchorElement, MouseEvent>, ctaType: string, ctaLink: ISleepExpertPicksCTALinkData, tealiumEvent: ITealiumEventData | undefined) => {
        event.preventDefault();
        var callBacks = {
            'chat': () => toggleChatOnClick(ctaLink, tealiumEvent),
            'call': () => callOnClick(ctaLink, tealiumEvent),
            'link': () => findStoreOnClick(ctaLink, tealiumEvent),
            'podium': () => textStoreOnClick(ctaLink, tealiumEvent)
        };
        if (ctaType in callBacks) {
            callBacks[ctaType]();
        }
    };

    const callOnClick = (ctaLink: ISleepExpertPicksCTALinkData, tealiumEvent: ITealiumEventData | undefined) => {
        if (MsDyn365.isBrowser) {
            // @ts-ignore
            if ('utag' in window) {
                // @ts-ignore
                utag.link({
                    event: tealiumEvent?.event,
                    event_type: tealiumEvent?.event_type,
                    event_category: tealiumEvent?.event_category,
                    event_action: tealiumEvent?.event_action,
                    event_label: tealiumEvent?.event_label,
                    event_noninteraction: 'false'
                });
            }
            window.location.href = `tel:${ctaLink.ariaLabel || 8773468775}`;
        }
    };

    const textStoreOnClick = (ctaLink: ISleepExpertPicksCTALinkData, tealiumEvent: ITealiumEventData | undefined) => {
        const pagePath = MsDyn365.isBrowser
            ? window.location.href.split(location.host)[1].includes('?')
                ? window.location.href.split(location.host)[1].split('?')[0]
                : window.location.href.split(location.host)[1]
            : '';
        if (MsDyn365.isBrowser) {
            // @ts-ignore
            if ('utag' in window) {
                // @ts-ignore
                utag.link({
                    event: tealiumEvent?.event,
                    event_category: tealiumEvent?.event_category,
                    event_action: tealiumEvent?.event_action,
                    event_label: `${tealiumEvent?.event_label} ${pagePath}`,
                    event_noninteraction: 'false'
                });
            }
            // @ts-ignore
            if ('PodiumWebChat' in window) {
                // @ts-ignore
                PodiumWebChat.open();
            } else {
                console.error('Podium Script Not Loaded');
            }
        }
    };

    const findStoreOnClick = (ctaLink: ISleepExpertPicksCTALinkData, tealiumEvent: ITealiumEventData | undefined) => {
        const openLinkInNewTab = ctaLink.openInNewTab ? '_blank' : '_self';
        if (MsDyn365.isBrowser) {
            // @ts-ignore
            if ('utag' in window) {
                // @ts-ignore
                utag.link({
                    event: tealiumEvent?.event,
                    event_category: tealiumEvent?.event_category,
                    event_action: tealiumEvent?.event_action,
                    event_label: tealiumEvent?.event_label,
                    event_noninteraction: 'false'
                });
            }
            if (ctaLink.linkUrl) {
                window.open(ctaLink.linkUrl.destinationUrl, openLinkInNewTab);
        }
        }
    };

    const toggleChatOnClick = (ctaLink: ISleepExpertPicksCTALinkData, tealiumEvent: ITealiumEventData | undefined) => {
        if (MsDyn365.isBrowser) {
            // @ts-ignore
            if ('utag' in window) {
                // @ts-ignore
                utag.link({
                    event: tealiumEvent?.event,
                    event_type: tealiumEvent?.event_type,
                    event_category: tealiumEvent?.event_category,
                    event_action: enableNewSleepExpertModule ? tealiumhChatEventActionText : tealiumEvent?.event_action ,
                    event_label: tealiumEvent?.event_label,
                    event_noninteraction: 'false'
                });
            }

            let c2c_counter = 0;
            const c2c_check = setInterval(() => {
                c2c_counter++;

                // @ts-ignore // The 3rd party script may not have yet loaded and initialized
                if (window.embedded_svc?.domInitInProgress === true) {
                    clearInterval(c2c_check);

                    // Trigger click event on live help button, minimized chat button, or sidebar minimized button
                    document
                        .querySelectorAll('.uiButton.helpButtonEnabled, .minimizedContainer.helpButton, .sidebarHeader.minimizedContainer')
                        .forEach(_elem => {
                            _elem.dispatchEvent(new Event('click'));
                        });
                } else {
                    // Stop trying for the button after 5 seconds
                    c2c_counter > 10 && clearInterval(c2c_check);
                }
            }, 500);
        }
    };

    const clipImage = props.config.seClipImage ? `${styles}__img__clip` : '';
    const chatEventConfig = props.config.seCTAList.find((sc, index) => {
          return sc.ctaType === "chat";
    });
    return (
       props.config.enableNewSleepExpertModule ? <div className='sleep-expert__container'>
             <div className='sleep-expert__title'>
                <span>
                    <RichTextComponent text={props.config.seTitle} />
                </span>
            </div>
            <div className='sleep-expert__content'>
                <span>
                    <RichTextComponent text={props.config.seContent} />
                </span>
            </div>
            <div className='sleep-expert__chat'>
                <button className='sleep-expert__chat-link' onClick={(e) => handleClick(e, chatEventConfig?.ctaType!, chatEventConfig?.sleepExpertPicksCTALink!, chatEventConfig?.tealiumEvent)} >
                    {props.config.chatWithSleepExpertLinkText}
                  <span className='caret' ><Caret /></span>
                </button>
                {/*  */}
            </div>
       </div>
        :
        <div className={`${styles}`} data-cy='d5-SleepExpert'>
        <div className={`${styles}__img`}>
            <Image
                {...props.config.seAvatarImage}
                alt={props.config.seAvatarImage?.altText}
                className={classname(`${styles}__img__avatar`, clipImage)}
                src={props.config.seAvatarImage?.src || ''}
                gridSettings={props.context.request.gridSettings!}
            />
        </div>
        <div className={`${styles}__wrapper`}>
            <div className={`${styles}__title`}>
                <span>
                    <RichTextComponent text={props.config.seTitle} />
                </span>
            </div>
            <div className={`${styles}__content`}>
                <span>
                    <RichTextComponent text={props.config.seContent} />
                </span>
            </div>
            <div className={`${styles}__button`}>
                {props.config.seCTAList.map((sc, index) => {
                    const { tealiumEvent, sleepExpertPicksCTALink, ctaType } = sc;
                    return (
                        <Button
                            className={'d5-mfrm-single-cta'}
                            key={index}
                            onClick={(e) => handleClick(e, ctaType, sleepExpertPicksCTALink, tealiumEvent)}
                        >
                            {sleepExpertPicksCTALink.linkText}
                        </Button>
                    );
                })}
            </div>
            {props.config.seCalloutMessage && (
                <div className={`${styles}__callout`}>
                    <span>
                        <RichTextComponent text={props.config.seCalloutMessage} />
                    </span>
                </div>
            )}
        </div>
    </div>
    );
};
